const mapModuleFilter = document.querySelector('.map-module__options');

const initDefaultMap = (maps) => {
  if (maps.length > 0) {
    maps.forEach((mapInit) => {
      const parentElem = mapInit.closest('.map-module');
      const mapLat = mapInit.getAttribute('data-lat');
      const mapLng = mapInit.getAttribute('data-lng');
      const mapZoom = mapInit.getAttribute('data-zoom');

      initializeMap(mapInit, parentElem, mapLat, mapLng, mapZoom);
    });
  }
};

const waitForElement = (selector, timeout = 1000) =>
  new Promise((resolve, reject) => {
    const interval = 100;
    let elapsedTime = 0;

    const checkExistence = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(checkExistence);
        resolve();
      }

      elapsedTime += interval;
      if (elapsedTime >= timeout) {
        clearInterval(checkExistence);
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }
    }, interval);
  });

if (mapModuleFilter) {
  const mapFilterItems = mapModuleFilter.querySelectorAll('input');
  const getLocationCategoryIds = () => {
    const ids = [];
    mapFilterItems.forEach((item) => {
      if (item.checked && item.value) {
        ids.push(item.value);
      }
    });
    return ids;
  };

  const locationListElement = document.querySelector('.map-module__list');
  const resultTextElement = document.querySelector('.map-module__result-text');
  const mapPinsElement = document.querySelector('.map-module__pins');
  const mapPopupElement = document.querySelector('.map-module__popup');
  // Axios get filtered locations
  const axiosGetFilteredLocations = async (goToPin = false) => {
    const formDataInput = {
      action: 'getFilteredLocations',
      ids: getLocationCategoryIds(),
      country: document.querySelector('.map-module__search .dropdown__list-item input:checked')?.id || '',
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      if (locationListElement && resultTextElement && response.data.data.html_list) {
        locationListElement.innerHTML = response.data.data.html_list;
        resultTextElement.innerHTML = response.data.data.html_result_text;
        mapPinsElement.innerHTML = response.data.data.html_pins;
        mapPopupElement.innerHTML = response.data.data.html_popup;
        initDefaultMap(document.querySelectorAll('.map-module__init-inner'));

        if (goToPin) {
          const defaultElement = '.gm-style [title="1"]';
          await waitForElement(defaultElement);
          document.querySelector(defaultElement)?.click();
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  // click event on checkbox to filter locations
  mapFilterItems.forEach((filterItem) => {
    filterItem.addEventListener('click', (e) => {
      let allChecked = true;
      mapFilterItems.forEach((item) => {
        if (e.target.id === 'find_all') {
          item.checked = e.target.checked;
        } else if (item.id === 'find_all' && !e.target.checked) {
          item.checked = false;
        }

        if (!item.checked && item.id !== 'find_all') {
          allChecked = false;
        }
      });
      mapModuleFilter.querySelector('#find_all').checked = allChecked;
      axiosGetFilteredLocations();
    });
  });

  // click event on dropdown to filter locations
  const mapSearchItems = document.querySelectorAll('.map-module__search .dropdown__list-item input');
  mapSearchItems.forEach((searchItem) => {
    searchItem.addEventListener('click', (e) => {
      axiosGetFilteredLocations(e.target.id !== 'all');
    });
  });

  // Get Lat/Lng on click of geo location button
  const geoLocationBtn = document.querySelector('.get-geolocation');

  const getLocation = (position) => {
    const { latitude, longitude } = position.coords;
    return [latitude, longitude];
  };

  geoLocationBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const [latitude, longitude] = getLocation(position);
        // you can use lat and long for filtering
        // eslint-disable-next-line no-console
        console.log(latitude, longitude);
      });
    }
  });
}

// -------
// Google Map
// -------
const gMaps = document.querySelectorAll('.map-module__init-inner');

const initializeMap = (mapElement, parentElement, mapLat, mapLng, mapZoom) => {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    styles: [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [{ visibility: 'on' }, { saturation: '-100' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#000A14' }, { visibility: 'on' }],
      },
      {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#000A14' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry.fill',
        stylers: [{ color: '#000A14' }],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#000A14' }],
      },
    ],
  };

  const map = new google.maps.Map(mapElement, mapOptions);
  const bounds = new google.maps.LatLngBounds();
  const markers = [];
  const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
  const mapPins = parentElement.querySelectorAll('.map-module__pins-info');

  const addMarker = (position, data, infoCard) => {
    const markerSvg = `
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 30H12.5" stroke="#000A14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M47.5 30H55" stroke="#000A14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M30 5V12.5" stroke="#000A14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M30 47.5V55" stroke="#000A14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M30 47.5C39.665 47.5 47.5 39.665 47.5 30C47.5 20.335 39.665 12.5 30 12.5C20.335 12.5 12.5 20.335 12.5 30C12.5 39.665 20.335 47.5 30 47.5Z" fill="#000A14" stroke="#000A14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" font-size="16px" font-family="PP Monument Extended, sans-serif" font-weight="bold" dy="1%">${data.id}</text>
      </svg>
    `;

    const markerIcon = {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(markerSvg)}`,
      scaledSize: new google.maps.Size(60, 60),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(30, 30),
    };

    const marker = new google.maps.Marker({
      position,
      map,
      icon: markerIcon,
      title: data.id,
    });

    markers.push({ data, marker });
    bounds.extend(marker.position);

    if (infoCard) {
      marker.addListener('click', () => {
        map.panTo(marker.getPosition());
        infoWindow.setContent(infoCard.innerHTML);
        infoWindow.open(map, marker);
      });
    }
  };

  const loadMarkers = () => {
    mapPins.forEach((mapPin) => {
      const pinLat = mapPin.getAttribute('data-markerlat');
      const pinLng = mapPin.getAttribute('data-markerlng');
      const targetPopup = mapPin.getAttribute('data-pin');
      const infoCard = document.querySelector(`[data-popup="${targetPopup}"]`);
      const mapLatLng = new google.maps.LatLng(pinLat, pinLng);
      const data = { id: targetPopup };

      addMarker(mapLatLng, data, infoCard);
    });
  };

  loadMarkers();
};

initDefaultMap(gMaps);

const locationCards = document.querySelectorAll('.map-module__list .location-card');

if (locationCards.length > 0) {
  attachEvent('.location-card', 'click', (e) => {
    const target = e.target.closest('.location-card');
    const footerLink = e.target.closest('.location-card__footer-item');

    if (footerLink) {
      return;
    }

    document.querySelectorAll('.map-module__list .location-card').forEach((card) => {
      card.classList.remove('is-active');
    });

    target.classList.add('is-active');

    const selectedPin = target.dataset.pin || '';

    if (selectedPin) {
      document.querySelector(`.gm-style [title="${selectedPin}"]`)?.click();
    }
  });
}
